import React from 'react'
import { useModalTranslation } from '../../i18n/useModalTranslation'
import LandPageModal from './LandPageModal'

const BG_FRAME_IMAGE =
  'https://s0swaypl0zqnzq8t.public.blob.vercel-storage.com/_merged_/session-modal/bg_new.webp'
const BUTTON_IMAGE =
  'https://s0swaypl0zqnzq8t.public.blob.vercel-storage.com/_merged_/session-modal/button_new.webp'
const MODAL_PANEL_BG = `url(${BG_FRAME_IMAGE}) center/contain no-repeat`

const HEADER_BORDER_COLOR = 'rgb(62, 48, 38)'
const BROWN_BTN_BORDER = 'rgba(118, 92, 68, 0.9)'

interface SessionExpiredModalProps {
  open: boolean
  onRefresh: () => void | Promise<void>
}

const SessionExpiredModal: React.FC<SessionExpiredModalProps> = ({ open, onRefresh }) => {
  const { t } = useModalTranslation()

  const handleRefresh = () => {
    void onRefresh()
  }

  return (
    <LandPageModal
      open={open}
      onClose={() => { }}
      width="90vw"
      maxWidth="820px"
      minHeight="auto"
      ariaLabelledBy="session-expired-modal-title"
      ariaDescribedBy="session-expired-modal-description"
      background={MODAL_PANEL_BG}
      closeButtonColor={BROWN_BTN_BORDER}
      accentColor={HEADER_BORDER_COLOR}
      hideCloseButton
      disableEscapeKeyDown
      contentNoScroll
      hideCornerBorders
      hideBorder
    >
      <div className="relative w-full flex flex-col min-h-[400px] sm:min-h-[450px] md:min-h-[500px] overflow-hidden items-end">
        <div className="flex-1 flex flex-col gap-2 sm:gap-3 md:gap-4 items-center justify-center py-8 px-6 sm:py-12 sm:px-8 md:py-16 md:pl-12 md:pr-16 lg:py-20 lg:pl-16 lg:pr-24 w-full sm:w-4/5 md:w-2/3">
          <h2
            id="session-expired-modal-title"
            className="text-base sm:text-lg md:text-xl lg:text-2xl font-bold text-center mb-2 sm:mb-3"
            style={{ fontFamily: 'Tilt Warp', color: 'rgba(255, 255, 255, 0.95)' }}
          >
            {t('modals.sessionExpired.title')}
          </h2>
          <p
            id="session-expired-modal-description"
            className="text-center mb-4 sm:mb-6 text-xs sm:text-sm md:text-base"
            style={{ color: 'rgba(228, 220, 200, 0.9)' }}
          >
            {t('modals.sessionExpired.description')}
          </p>
          <button
            onClick={handleRefresh}
            className="relative rounded-xl overflow-hidden flex items-center justify-center border-none w-full max-w-[340px] sm:max-w-[360px] md:max-w-[380px]"
          >
            <img
              src={BUTTON_IMAGE}
              alt=""
              className="w-44 object-cover pointer-events-none"
            />
            <span
              className="absolute inset-0 flex items-center justify-center z-10 text-sm sm:text-base font-normal"
              style={{ fontFamily: 'Tilt Warp', color: 'rgba(255, 255, 255, 0.95)' }}
            >
              {t('modals.sessionExpired.refresh')}
            </span>
          </button>
        </div>
      </div>
    </LandPageModal>
  )
}

export default SessionExpiredModal
